import { useState, useEffect, useCallback } from 'react';
import api from '../api/axios';
import toast from 'react-hot-toast';
import { MdDelete, MdPerson, MdDevices } from 'react-icons/md';

export default function Comments() {
  const [comments, setComments] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
  const [loading, setLoading] = useState(true);

  const fetchComments = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await api.get('/admin/comments', { params: { page, limit: 30 } });
      setComments(res.data.data);
      setPagination(res.data.pagination);
    } catch (err) {
      toast.error('Failed to load comments');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchComments(); }, [fetchComments]);

  const deleteComment = async (id) => {
    if (!window.confirm('Delete this comment?')) return;
    try {
      await api.patch(`/admin/comments/${id}/delete`);
      toast.success('Comment deleted');
      fetchComments(pagination.page);
    } catch (err) {
      toast.error('Delete failed');
    }
  };

  if (loading) return <div className="page-loader">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Comments</h2>
        <span className="badge">{pagination.total} total</span>
      </div>

      {comments.length === 0 ? (
        <div className="empty-state">
          <h3>No comments yet</h3>
          <p>Comments from users will appear here.</p>
        </div>
      ) : (
        <>
          <div className="comments-list">
            {comments.map(c => (
              <div key={c.id} className={`card comment-card ${c.is_deleted ? 'comment-deleted' : ''}`}>
                <div className="comment-header">
                  <div className="comment-author">
                    {c.is_guest ? <MdDevices className="comment-author-icon" /> : <MdPerson className="comment-author-icon" />}
                    <span className="comment-name">{c.author}</span>
                    {c.is_reply && <span className="badge">Reply</span>}
                    {c.is_deleted && <span className="badge badge-expired">Deleted</span>}
                  </div>
                  {!c.is_deleted && (
                    <button className="btn btn-sm btn-danger" onClick={() => deleteComment(c.id)}>
                      <MdDelete />
                    </button>
                  )}
                </div>
                <p className="comment-body">{c.body}</p>
                <div className="comment-meta">
                  <span className="comment-article">on: {c.article_title}</span>
                  <span>{c.like_count} likes</span>
                  <span>{new Date(c.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            ))}
          </div>

          {pagination.pages > 1 && (
            <div className="pagination">
              {Array.from({ length: pagination.pages }, (_, i) => (
                <button key={i} className={`page-btn ${pagination.page === i + 1 ? 'active' : ''}`}
                  onClick={() => fetchComments(i + 1)}>
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
